import type { IntakeDetails } from "@/api";

export const VALUE_TYPE_SUBTITLE = "subtitle";

export const buildAddressDetailsCardData = (
  addressInformation: IntakeDetails["addressInformation"],
  hasSameShipping: boolean,
) => {
  if (!addressInformation) return [];

  if (hasSameShipping) {
    return [
      {
        label: "Street Address",
        value: addressInformation.billingAddress,
      },
      {
        label: "City",
        value: addressInformation.billingCity,
      },
      {
        label: "State",
        value: addressInformation.billingState,
      },
      {
        label: "ZIP Code",
        value: addressInformation.billingZipCode,
      },
      {
        label: "Billing address",
        value: "Same as shipping",
      },
    ];
  }

  return [
    {
      label: "Billing address",
      value: VALUE_TYPE_SUBTITLE,
    },
    {
      label: "Street address",
      value: addressInformation.billingAddress,
    },
    {
      label: "City",
      value: addressInformation.billingCity,
    },
    {
      label: "State",
      value: addressInformation.billingState,
    },
    {
      label: "ZIP Code",
      value: addressInformation.billingZipCode,
    },

    {
      label: "Shipping Address",
      value: VALUE_TYPE_SUBTITLE,
    },
    {
      label: "Street address",
      value: addressInformation.shippingAddress,
    },

    {
      label: "City",
      value: addressInformation.shippingCity,
    },
    {
      label: "State",
      value: addressInformation.shippingState,
    },
    {
      label: "ZIP Code",
      value: addressInformation.shippingZipCode,
    },
  ];
};
